import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DownloadListComponent } from './download-list/download-list.component';

export const downloadRoutes: Routes = [
  {
    path: 'download',
    component: DownloadListComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(downloadRoutes)],
  exports: [RouterModule]
})
export class DownloadRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/download/download-routing.module.ts